import type {
  CollapsibleTextDSProps,
  LayoutClassType,
} from './CollapsibleText.types';

export const isAutoWidth: (
  props: Partial<CollapsibleTextDSProps>,
) => boolean = ({ ellipsis, wrappingStyle }) =>
  !ellipsis && wrappingStyle === 'single-line';

export const getLayoutClass = (withLogicalLayout: boolean): LayoutClassType =>
  withLogicalLayout ? 'logicalLayout' : 'physicalLayout';
